module.exports = __webpack_public_path__ + "static/media/change-direction-icon.168ae261.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/change-direction-icon.svg
// module id = 666
// module chunks = 0